import React, { useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { Card, CardBody } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import { getTotalPaymentsAmount } from "common/services/payments.service";
import CardWidgetSkeleton from "Components/Common/CardWidgetSkeleton";
import { CurrencyFormat, formatCurrencySuffix } from "common/lib/currency";
import useQueryState from "Components/Hooks/UseQueryState";
import { getYearDateRange } from "common/lib/dateUtils";
import { Link } from "react-router-dom";

const TotalSupport = () => {
  const [loading, setLoading] = useState(false);
  const [totalActiveSupport, setTotalActiveSupport] = useState(0);
  const [totalSupport, setTotalSupport] = useState<CurrencyFormat>({
    amount: 0,
    suffix: "",
    formattedString: "",
    exactAmount: 0,
  });

  const [selectedYear] = useQueryState(
    "year",
    new Date().getFullYear().toString()
  );
  const { firstDay, lastDay } = getYearDateRange(selectedYear);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getTotalPaymentsAmount({
          startDate: firstDay,
          endDate: lastDay,
        });
        setTotalSupport(formatCurrencySuffix(response?.totalAmount));
      } catch (error) {
        console.warn("Error fetching total active support", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [firstDay, lastDay]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getTotalPaymentsAmount({
          startDate: firstDay,
          endDate: lastDay,
          active: true,
        });
        setTotalActiveSupport(response?.totalAmount);
      } catch (error) {
        console.warn("Error fetching total active support", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [firstDay, lastDay]);

  const percentageValue = useMemo(() => {
    if (totalSupport.exactAmount === 0) return 0;
    return (totalActiveSupport / totalSupport?.exactAmount) * 100;
  }, [totalActiveSupport, totalSupport]);

  if (loading) {
    return <CardWidgetSkeleton />;
  }

  return (
    <Link to={"/payments"}>
      <Card className="card-animate mb-4 card-bottom-primary">
        <CardBody className="">
          <div className="d-flex justify-content-between">
            <div>
              <p className="fw-medium text-muted mb-0">Total Support</p>
              <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
                <span className="counter-value">
                  <CountUp
                    start={0}
                    end={totalSupport?.amount}
                    decimals={1}
                    duration={1}
                  />
                </span>
                {totalSupport?.suffix}
              </h2>
              <p className="mb-0 text-muted text-truncate">
                <span className="badge bg-light text-success mb-0 me-2">
                  {percentageValue.toFixed(2)}%
                </span>
                currently active
              </p>
            </div>
            <div>
              <div className="avatar-sm flex-shrink-0">
                <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                  <FeatherIcon icon="dollar-sign" className="text-success" />
                </span>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Link>
  );
};

export default TotalSupport;
